import { Tabs } from 'antd';
import React, { useState, useMemo, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { goAgentChat } from '@/utils/go-agent-chat';

const MoreAgent = observer(
  ({ moreAgents = [], agentCategories = [], loading = false, error = null }) => {
    const [activeKey, setActiveKey] = useState(0)

    // 根据当前选中的tab过滤服务
    const filteredServices = useMemo(() => {
      const cate = agentCategories[activeKey]?.title || ''
      return moreAgents.filter(agent => agent.category === cate);
    }, [activeKey, moreAgents]);

    useEffect(() => {
      if (agentCategories.length > 0) {
        setActiveKey(0)
      }
    }, [agentCategories]);

    if (loading) {
      return (
        <div className="max-w-800px min-w-652px w-full mt-44px mb-4px">
          <div className="text-black mb-16px">
            <span className="text-14px font-bold">更多Agent</span>
          </div>
          {/* 分类Tab骨架屏 */}
          <div className="flex gap-4px p-4px bg-[rgba(37,45,77,0.05)] rounded-[6px] mb-20px">
            {[1, 2, 3, 4].map(index => (
              <div key={index} className="h-32px w-20 bg-gray-200 rounded animate-pulse"></div>
            ))}
          </div>
          <div className="container mx-auto">
            <div className="grid grid-cols-3 gap-16px">
              {[1, 2, 3, 4, 5, 6].map(index => (
                <div
                  key={index}
                  className="border-1px border-[rgba(37, 45, 77, 0.05)] rounded-12px bg-[rgba(37, 45, 77, 0.03)] p-16px flex"
                >
                  <div className="size-64px bg-gray-200 rounded-full mr-16px animate-pulse"></div>
                  <div className="flex-1">
                    <div className="h-6 bg-gray-200 rounded mb-2 animate-pulse"></div>
                    <div className="h-4 bg-gray-200 rounded animate-pulse"></div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      );
    }

    if (error) {
      return null;
    }

    return (
      <div className="max-w-800px min-w-652px w-full mt-44px mb-4px">
        <div className="text-black mb-16px">
          <span className="text-14px font-bold">更多Agent</span>
        </div>
        <Tabs
          activeKey={activeKey}
          onChange={(key) => setActiveKey(Number(key))}
          items={agentCategories.map((cate, i) => {
            return {
              label: cate.title,
              key: i,
            }
          })}
        />
        <div className="container mx-auto">
          <div className="grid grid-cols-3 gap-16px">
            {filteredServices.map((service) => (
              <div
                key={service.uuid}
                className={[
                  'border-1px border-[rgba(37, 45, 77, 0.05)] rounded-12px',
                  'bg-[rgba(37, 45, 77, 0.03)] p-16px flex cursor-pointer',
                ]}
                onClick={() => goAgentChat(service)}
              >
                <img
                  src={service.icon}
                  alt={service.title}
                  className="size-64px  object-cover rounded-full mr-16px"
                />
                <div className="text-left flex-1 overflow-hidden">
                  <h2 className="leading-24px font-16px mb-2px truncate">{service.title}</h2>
                  <div className="leading-22px line-clamp-2 overflow-hidden text-ellipsis">
                    {service.intro}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
);
export default MoreAgent;
